import { useQuery } from '@tanstack/react-query';

import { FAQPage } from '../../copied/models/ChatModules';
import fetchSearchResults from '../../services/search';
import useFetchHelpCenter from './useFetchHelpCenter';

export default function useFetchSearchResults({
  search,
  suggested,
  category,
  traceId,
}: {
  search?: string;
  suggested?: boolean;
  category?: string;
  traceId?: string;
}) {
  const { data } = useFetchHelpCenter();

  return useQuery<{ results: FAQPage[] }>({
    queryKey: ['search', data?.uuid, search, suggested, category, traceId],
    queryFn: () =>
      fetchSearchResults({
        uuid: data?.uuid,
        search,
        suggested,
        category,
        traceId,
      }),
    enabled: !!data?.uuid,
  });
}
